import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MarkdownModule } from 'ngx-markdown';

import { MessagepopupComponent } from '../../dialog/messagepopup/messagepopup.component';

import { RestapiService } from '@services/restapi.service';

@Component({
  selector: 'app-save-money-energy-bills',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MarkdownModule, MessagepopupComponent],
  templateUrl: './save-money-energy-bills.component.html',
  styleUrls: ['./save-money-energy-bills.component.scss']
})
export class SaveMoneyEnergyBillsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  section5: any = {};
  section5Tile1: any = {};
  section5Tile2: any = {};
  section5Tile3: any = {};

  constructor(
    public dialog: MatDialog,
    private restApi: RestapiService
  ) {
    this.getMarkdownFile('dashboard/dashboard-section5.md', 'section5');
    this.getMarkdownFile('dashboard/dashboard-section5-tile1-content.md', 'section5Tile1');
    this.getMarkdownFile('dashboard/dashboard-section5-tile2-content.md', 'section5Tile2');
    this.getMarkdownFile('dashboard/dashboard-section5-tile3-content.md', 'section5Tile3');
  }

  ngOnInit() {
  }

  // Get markdown file from S3 bucket
  getMarkdownFile(path: string, condition?: string): void {
    this.subscriptions.push(
      this.restApi.getS3FileAPI(path).subscribe(data => {
        // Split by double new line
        let splitData: any[] = data.split('\n\n');

        if (condition === 'section5') {
          // Get the title of modal
          this.section5['title'] = splitData[0];

          // Shift method to pop content from top
          splitData?.shift();

          // Rest of the content is join with new line
          this.section5['content'] = splitData.join('\n');
        } else if (condition === 'section5Tile1') {
          // Get the title of modal
          this.section5Tile1['title'] = splitData[0];

          // Shift method to pop content from top
          splitData?.shift();

          // Rest of the content is join with new line
          this.section5Tile1['content'] = splitData.join('\n');
        } else if (condition === 'section5Tile2') {
          // Get the title of modal
          this.section5Tile2['title'] = splitData[0];

          // Shift method to pop content from top
          splitData?.shift();

          // Rest of the content is join with new line
          this.section5Tile2['content'] = splitData.join('\n');
        } else if (condition === 'section5Tile3') {
          // Get the title of modal
          this.section5Tile3['title'] = splitData[0];

          // Shift method to pop content from top
          splitData?.shift();

          // Rest of the content is join with new line
          this.section5Tile3['content'] = splitData.join('\n');
        }
      }, err => {
        console.log('ERROR: ', err);
      })
    )
  }

  // Message popup
  messagePopup(fileName): void {
    const dialogRef = this.dialog.open(MessagepopupComponent, {
      data: {
        key: fileName
      },
      // maxWidth: '570px',
      maxWidth: window.innerWidth <= 767 ? '95vw' : '600px',
      disableClose: true,
      autoFocus: false,
      panelClass: 'ctm-modal'
    });
  }

  // Compare the market 
  compareInsurance(): void {
    window.open('https://www.comparethemarket.com/', '_blank')
  }

  // Saving tips
  savingsTips(): void {
    window.open('https://www.comparethemarket.com/energy/content/energy-saving-tips/', '_blank')
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    })
  }
}
